// constants
import { AnalyticsActionTypes } from "./constants";

//Action
export interface AnalyticsActionType {
  type:
    | AnalyticsActionTypes.GET_ANALYTICS
    | AnalyticsActionTypes.GET_ANALYTICS_SUCCESS
    | AnalyticsActionTypes.GET_ANALYTICS_ERROR;
  payload: {} | string;
}

//Interfaces
interface AnalyticsData {
  data?: any;
}

//Affiliate_List
export const getAnalyticsSuccess = (
  actionType: string,
  data: AnalyticsData | {}
): AnalyticsActionType => ({
  type: AnalyticsActionTypes.GET_ANALYTICS_SUCCESS,
  payload: { actionType, data },
});

export const getAnalyticsError = (
  actionType: string,
  error: string
): AnalyticsActionType => ({
  type: AnalyticsActionTypes.GET_ANALYTICS_ERROR,
  payload: { actionType, error },
});

export const getAnalytics = (
  country: string = "ic",
  seller: string = "",
  startDate,
  endDate,
  boutique: string = ""
): AnalyticsActionType => ({
  type: AnalyticsActionTypes.GET_ANALYTICS,
  payload: { country, seller, startDate, endDate, boutique },
});
